import React from "react";

interface Props {
	text: string;
	href: string;
	linkStyle: string;
}

export const FixedLinkParser: React.FC<Props> = ({ text, href, linkStyle }) => {
	const bracketRegex = /\[([^\]]+)]/g;

	const parts: (string | JSX.Element)[] = [];
	let lastIndex = 0;
	let match: RegExpExecArray | null;

	while ((match = bracketRegex.exec(text)) !== null) {
		const [fullMatch, label] = match;
		const matchIndex = match.index;

		// Добавляем текст до конструкции
		if (lastIndex < matchIndex) {
			parts.push(text.slice(lastIndex, matchIndex));
		}

		// Добавляем ссылку
		parts.push(
			<a className={linkStyle}
				key={matchIndex}
				href={href}
				target="_blank"
				rel="noopener noreferrer"
			>
				{label}
			</a>
		);

		lastIndex = matchIndex + fullMatch.length;
	}

	// Добавляем оставшийся текст
	if (lastIndex < text.length) {
		parts.push(text.slice(lastIndex));
	}

	return <>{parts}</>;
};